import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { typedQueryClient, useTypedMutation } from "hooks";
import { CheckInServicesQueryKeys } from "modules/CheckInServices/queryKeys";
import { ApiInstance } from "utils/Api";

export const useEnableCheckInServiceMutation = () => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedMutation<number, void>({
    mutationFn: id => ApiInstance.post("/check_in/service/enable", { dealer_location_id: selectedLocation?.id, id }),
    onSuccess: id => {
      const dealerServices = typedQueryClient.getQueryData(CheckInServicesQueryKeys.dealerList);
      const locationServices = typedQueryClient.getQueryData(CheckInServicesQueryKeys.locationList);
      if (!dealerServices || !locationServices) return;

      const enabledService = dealerServices.find(service => service.id === id);
      if (!enabledService) return;

      typedQueryClient.setQueryData(CheckInServicesQueryKeys.locationList, [...locationServices, enabledService]);
    }
  });
};
